<template>
  <div class="wrapper wrapper-default">
    <!-- 头部s -->
    <s-header :getlogin="islogin">{{title}}</s-header>
    <!-- 头部e -->
    <div class="infomation-con">
      <div class="infomation-item flexBox flexAlignCenter flexBetween">
        <div class="infomation-item-name">登录账号</div>
        <div class="infomation-item-con">{{userInfo.mobile}}</div>
      </div>
      <div class="infomation-item flexBox flexAlignCenter flexBetween">
        <div class="infomation-item-name">用户名</div>
        <div class="infomation-item-con">{{userInfo.username}}</div>
      </div>
      <button type="button" class="infomation-btn" @click="logout">退出登录</button>
    </div>
  </div>
</template>
<script>
import Cookie from "js-cookie";
export default {
  metaInfo: {
    title: "个人信息"
  },
  data() {
    return {
      baseLink: process.env.VUE_APP_BASE_LINK,
      title: "个人信息",
      userInfo: {},
      islogin: false
    };
  },
  methods: {
    logout() {
      this.$dialog
        .confirm({
          message: "确认要退出登录吗？"
        })
        .then(() => {
          this.$axios.get("/logout.json").then(res => {
            if (res.code == "0000") {
              Cookie.remove("_login_id");
              this.$router.push({
                path: "/"
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  async created() {
    let res = await this.$axios.get("/userInfo.json");
    this.islogin = res.success ? true : false;
    this.userInfo = res.data;
  }
};
</script>
<style lang="less">
.infomation-con {
  padding: 0.2rem 0.2rem 0;
}

.infomation-item {
  height: 1rem;
  border-radius: 0.12rem;
  background-color: #fff;
  margin-bottom: 0.2rem;
  padding: 0 0.3rem 0 0.26rem;

  &-name {
    font-size: 0.3rem;
    color: #333;
  }

  &-con {
    font-size: 0.26rem;
    color: #999;
  }
}

.infomation-btn {
  font-size: 0.3rem;
  width: 100%;
  height: 1rem;
  border: 0;
  border-radius: 0.12rem;
  color: #ff6700;
  background-color: #fff;
}
</style>
